import { createVolumeAutocompleteFilter } from './common/createVolumeAutocompleteFilter';

export default createVolumeAutocompleteFilter({
  field: 'region',
  groupLabel: 'Region',
  mustTypeFirstMessage: 'Start typing region',
  defaultQuery: 'us-',
  logPrefix: '[RegionFilter]',
});
